import { useEffect } from "react";

import store from "../redux/app/store";
// Redux
import { logoutUser } from "../redux/features/userState/userStateSlice";
import {
  // setAppOpen,
  partialResetApplication,
} from "../redux/features/applicationState/applicationStateSlice";
import { resetPatient } from "../redux/features/patientState/patientStateSlice";

import toastManager from "../helpers/toastManager";

export const useInactivityLogout = (timeoutDuration) => {
  useEffect(() => {
    let timer;

    const logoutHandler = () => {
      store.dispatch(partialResetApplication());
      store.dispatch(logoutUser());
      store.dispatch(resetPatient());

      toastManager(
        "warning",
        "Logged Out: Inactivity Detected",
        "For your security, you've been automatically logged out after a period of inactivity. Please log in again to continue."
      );
    };

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(logoutHandler, timeoutDuration);
    };

    // Set up event listeners for user activity
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("scroll", resetTimer);
    window.addEventListener("click", resetTimer);

    // Initialize timer
    timer = setTimeout(logoutHandler, timeoutDuration);

    // Cleanup function
    return () => {
      clearTimeout(timer);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("scroll", resetTimer);
      window.removeEventListener("click", resetTimer);
    };
  }, [timeoutDuration]);
};
